import { getUserTimeZone } from 'shared/utils/common';
import * as signalR from '@microsoft/signalr';
import { AppDispatch } from 'app/store';
import { StateResponse } from 'features/TimeTracking/state/timeTrackingInterfaces';
import { GetSessionState, GetTimeTrackingData, setCurrentState } from 'features/TimeTracking/state/timeTrackingSlice';
import { API_TT_HUB_BASE_URL } from 'config/env';

if (!API_TT_HUB_BASE_URL) {
  throw new Error("REACT_APP_API_TT_HUB_BASE_URL is not defined");
}

const baseHubUri: string = API_TT_HUB_BASE_URL;

// Read at the moment of use, never captured: GetSessionState replaces HubToken (a JWT the backend
// issues for 12 h) on every call, and SignalR asks accessTokenFactory again on each negotiate -
// including every automatic reconnect of the same connection. A captured value outlives its expiry
// and every reconnect after that is rejected.
const readHubToken = () => {
  const rememberMe = JSON.parse(localStorage.getItem('rememberMe') as string);
  return rememberMe
    ? localStorage.getItem('HubToken')
    : sessionStorage.getItem('HubToken');
};

class TimeTrackingHub {
  public hubConnection: signalR.HubConnection | null = null;
  private dispatch: AppDispatch;

  constructor(dispatch: AppDispatch) {
    this.dispatch = dispatch;
  }

  public startConnection = async () => {
    if (!readHubToken()) return;

    this.hubConnection = new signalR.HubConnectionBuilder()
      .withUrl(baseHubUri, {
        accessTokenFactory: async () => readHubToken() || '',
      })
      .configureLogging(signalR.LogLevel.Warning)
      .withAutomaticReconnect()
      .build();

    this.hubConnection.serverTimeoutInMilliseconds = 60000;

    this.hubConnection.on('SessionStateChanged', (payload: StateResponse) => {
      this.dispatch(setCurrentState(payload));
    });

    this.hubConnection.on('ProjectsChanged', () => {
      this.dispatch(GetTimeTrackingData());
      this.dispatch(GetSessionState({ timeZone: getUserTimeZone() }));
    });

    this.hubConnection.on('AssignmentsChanged', () => {
      this.dispatch(GetTimeTrackingData());
      this.dispatch(GetSessionState({ timeZone: getUserTimeZone() }));
    });

    await this.hubConnection.start().then(() => console.log('time tracking connected')).catch(err => console.log(err));

  };

  public stopConnection = async () => {
    if (this.hubConnection) {
      await this.hubConnection.stop();
      console.log('time tracking connection stopped.');
    }
  };
}

export default TimeTrackingHub;